"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalePhase = exports.PricingType = void 0;
var PricingType;
(function (PricingType) {
    PricingType["DEFAULT"] = "default";
    PricingType["DUTCH_AUCTION"] = "dutch-auction";
})(PricingType = exports.PricingType || (exports.PricingType = {}));
var SalePhase;
(function (SalePhase) {
    SalePhase["LOADING"] = "loading";
    SalePhase["DEACTIVATED"] = "deactivated";
    SalePhase["SOLD_OUT"] = "sold_out";
    SalePhase["EXPIRED"] = "expired";
    SalePhase["TO_CLAIM"] = "to-claim";
    SalePhase["CLAIM"] = "claim";
    SalePhase["TO_PRESALE"] = "to-presale";
    SalePhase["TO_PUBLIC_SALE"] = "to-public-sale";
    SalePhase["PRESALE"] = "presale";
    SalePhase["PUBLIC_SALE"] = "public-sale";
})(SalePhase = exports.SalePhase || (exports.SalePhase = {}));
